/**
 * Share payload for the player's share button — pure so it can be unit
 * tested without `navigator.share`/`navigator.clipboard` (see
 * src/lib/share.test.ts). The caller (Listen.tsx) does the actual sharing.
 *
 * A `kind: "custom"` story is personalised for one child (see
 * `AudioTrack.subtitle` in StoryDetail's `handleListen`, built from
 * `story.child.first_name`) and is private to the family — sharing its
 * `/story/:id` link would leak that name to whoever receives it. The share
 * button stays available for those tracks, but shares the app itself
 * instead of the story. Only `kind: "catalog"` — the public catalogue,
 * outside `RequireAuth` (see /story/:id in App.tsx) — gets a direct link.
 * A track with no `kind` at all (older caller that never set it) is treated
 * the same as "custom": the safe default is to not leak a link that might
 * be private.
 */
import type { StoryKind } from "./types";

export interface ShareableTrack {
  id: string;
  title: string;
  kind?: StoryKind;
}

export interface SharePayload {
  url: string;
  title: string;
  text: string;
}

export function buildSharePayload(track: ShareableTrack, origin: string): SharePayload {
  if (track.kind === "catalog") {
    return {
      url: `${origin}/story/${track.id}`,
      title: track.title,
      text: `Une histoire du soir à écouter avec Chouette : ${track.title}`,
    };
  }
  return {
    url: `${origin}/`,
    title: "Chouette",
    text: "Je crée des histoires du soir pour mes enfants avec Chouette",
  };
}
